import './PageNotFound.scss'
import logoGeniux from '../../../assets/logo-blue.svg'
import { Link } from 'wouter'

const PageNotFound = () => {
  return (
    <div className="nd-grid page-not-found">
      <h1 className="poppins-40 c-blue mt-50">Oops, Página no encontrada - 404</h1>
      <img src={logoGeniux}  alt="Logo Geniux" />
      <Link href="/dashboard"><span className="source-16 bold c-blue link">Ir al dashboard</span></Link>
    </div>
  )
}

export default PageNotFound
